export default __webpack_public_path__ + "static/media/cn-telegram.c5302745.svg";